import * as React from "react";
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';
import {
  Drawer,
  Button,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  Tooltip,
} from "@mui/material";
import {
  Delete as DeleteIcon,
  Security as SecurityIcon,
  PlayArrow as PlayArrowIcon,
  SettingsSuggest as SettingsSuggestIcon,
  FormatListBulleted as FormatListBulletedIcon,
  SaveAlt as SaveAltIcon,
  AccessTime as AccessTimeIcon,
  Add as AddIcon,
  MoreVert as MoreVertIcon,
  ExpandMore as ExpandMoreIcon,
} from "@mui/icons-material";
import HelpIcon from '@mui/icons-material/Help';
import IconButton from "@mui/material/IconButton";
import OutputIcon from "@mui/icons-material/Output";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemButton from "@mui/material/ListItemButton";
import ListSubheader from '@mui/material/ListSubheader';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { Badge } from '@mui/material';
import dayjs from 'dayjs';
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Collapse from "@mui/material/Collapse";
import CircularProgress from '@mui/material/CircularProgress';
import Alert from "@mui/material/Alert";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import AppContext from "../../utils/context";
import CustomJsonForm from "../../components/customform";
import { buildSchema } from "../../utils/schema";

import { useDialogs } from "@toolpad/core/useDialogs";

export default function ComponentsDrawer(props) {
  const dialogs = useDialogs();
  const { t } = useTranslation();
  const appContext = React.useContext(AppContext); // AB added
  //const { events, database, router } = React.useContext(AppContext);
  const { events, database, router, user } = appContext; // AB added : replace previous

  const [workspaceId, setWorkspaceId] = React.useState(null);
  const [projectId, setProjectId] = React.useState(null);

  const [isDrawerServices, setDrawerServices] = React.useState(false);
  const [instance, setInstance] = React.useState(null);
  const [services, setServices] = React.useState([]);
  const [configurations, setConfigurations] = React.useState([]);
  const [anchorElService, setAnchorElService] = React.useState(null);
  const [anchorServiceMenuItem, setAnchorServiceMenuItem] = React.useState(null);
  const [openServiceCategory, setOpenServiceCategory] = React.useState([]);

  const [countScheduledConfigs, setCountScheduledConfigs] = React.useState(0);

  const [isDrawerConfigCron, setIsDrawerConfigCron] = React.useState(false);
  const [configurationsTimeline, setConfigurationsTimeline] = React.useState([]);
  const [isCron, setIsCron] = React.useState(false);
  const [currentTimelineConfig, setCurrentTimelineConfig] = React.useState(null);
  const [selectedDate, setSelectedDate] = React.useState(null);

  const [isDrawerConfigForm, setIsDrawerConfigForm] = React.useState(false);
  const [configuration, setConfiguration] = React.useState(null);
  const [schema, setSchema] = React.useState({});
  const [uischema, setUischema] = React.useState({});
  const [hasTriedToSave, setHasTriedToSave] = React.useState(false);
  const [formData, setFormData] = React.useState({});
  const [previsouFormData, setPrevisouFormData] = React.useState({});
  const [debounceTimer, setDebounceTimer] = React.useState(null);
  const [formErrors, setFormErrors] = React.useState(null);

  const [isDrawerDetails, setIsDrawerDetails] = React.useState(false);
  const [configurationDetails, setConfigurationDetails] = React.useState({});

  const [isRunning, setIsRunning] = React.useState([]); // list of services ids

  const helpConfigurationMsg = t('configurations.help.message', { defaultValue: undefined });
  const helpConfigurationLink = t('configurations.help.url', { defaultValue: undefined });

  const helpConfigurationCronMsg = t('configurations_timeline.help.message', { defaultValue: undefined });
  const helpConfigurationCronLink = t('configurations_timeline.help.url', { defaultValue: undefined });

  const [isWriteAccess, setWriteAccess] = React.useState(false);

  React.useEffect(() => {
    const offList = events.on("list-services", (e) => {
      console.log(e)
      setWriteAccess(e?.write);
      loadServices(e.instance)
    });
    return () => {
      offList();
    };
  }, []);
  
  /*    BLOC AB :  polling **************/
  React.useEffect(() => {
    if (!isDrawerServices) return; // Pas visible ? Pas de polling

    let active = true;
    const start = Date.now(); // arrêter après
    const maxDuration = 15 * 60 * 1000; // x minutes

    const poll = async () => {
       if (!active || Date.now() - start > maxDuration) return;
      await loadServices(instance);
      setTimeout(poll, 5000); //  toutes les 5s
    };

    poll(); // lancement immédiat

    return () => { active = false }; //  arrêt si drawer fermé ou component démonté
  }, [isDrawerServices, instance?.id]);

  // AB : get user roles
  const userRoles = appContext.user?.role ?? [];
  const isSystem = userRoles.includes('system') || userRoles.includes('owner_system');

  // added AB : metadata
  const loadServices = async (instanceD) => {
    const { data: instanceData } = await database
      .from("instances")
      .select("id, component_id, components(id, name, description, logo), hidden_services, project_id, metadata")
      .eq("id", instanceD.id)
      .single();

    setInstance(instanceData);

    const query = database
      .from("components_services")
      .select("services(id, name, description, logo, category, system_name, weight)")
      .eq("component_id", instanceData.component_id);

    if (instanceData?.hidden_services?.length > 0) {
      let r = instanceData.hidden_services.join(',');
      query.not("services.system_name", 'in', "(" + r + ")");
    }

    const { data: servicesData } = await query;

    const { data: configurationsData } = await database
      .from("configurations")
      .select("service_id, metadata, last_http_id, last_http_status")
      .eq("instance_id", instanceData.id);


    const { data: configurationsTimelineData } = await database
      .from("configurations_timeline")
      .select("service_id, services:count()")
      .eq("instance_id", instanceData.id)
      .eq("applied", false);
    setCountScheduledConfigs(configurationsTimelineData);

    setServices((servicesData || [])
      .filter(item => item.services != null)
      .sort((a, b) => a.services.weight - b.services.weight));
    setConfigurations(configurationsData || []);
    setDrawerServices(true);

    setProjectId(instanceData?.project_id);
    setWorkspaceId(instanceData?.projects?.workspace_id);
  };

  const groupedServices = React.useMemo(() => {
    const groups = {};
    services.forEach((s) => {
      const category = s.services.category || t('commons.uncategorized');
      if (!groups[category]) {
        groups[category] = [];
      }
      groups[category].push(s);
    });
    return groups;
  }, [services]);

  React.useEffect(() => {
    // Open all categories by default
    const categories = Object.keys(groupedServices);
    setOpenServiceCategory(categories);
  }, [groupedServices]);

  const isServiceConfiguration = (serviceId) => {
    return configurations.some(({ service_id }) => service_id === serviceId);
  }

  const isHttpError = (serviceId) =>
    configurations.some(
      ({ service_id, last_http_status }) =>
        service_id === serviceId &&
        (last_http_status >= 400 || last_http_status < 200)
    );

  const isHttpLoading = (serviceId) =>
    isRunning.includes(serviceId) ||
    configurations.some(
      ({ service_id, last_http_status }) =>
      (service_id === serviceId &&
        last_http_status == 202)
    );

  const isHttpBlocked = (serviceId) =>
    isHttpLoading(serviceId) ||
    configurations.some(
      ({ service_id, last_http_status }) =>
        service_id === serviceId &&
        (last_http_status == 504)
    );

  // Fonction utilitaire pour récupérer les données de configuration
  const fetchConfigurationData = async (serviceId, instanceId) => {
    const { data, error } = await database
      .from("configurations")
      .select(
        "metadata, services(id, name, jsonschema, jsonschema_form, logo), service_id, instance_id, last_http_status"
      )
      .eq("service_id", serviceId)
      .eq("instance_id", instanceId)
      .single();

    if (error) {
      events.dispatch("alert-message", {
        data: { message: t('commons.errors.fetching'), severity: "error" },
      });
    }

    return data;
  };

  // Fonction utilitaire pour exécuter un service
  const runService = async (instanceId, serviceId, action) => {

    setIsRunning((prev) => [...prev, serviceId]);
    try {
      await database.rpc("run_service", {
        qinstance_id: instanceId,
        qservice_id: serviceId,
        qaction: action,
      });
      return true;
    } catch (error) {
      events.dispatch("alert-message", {
        data: { message: t('configurations.errors.run_service', { action: action }), severity: "error" },
      });
      return false;
    } finally {
      setTimeout(() => {
        setIsRunning((prev) => prev.filter((id) => id !== serviceId));
      }, 1000);
    }
  };

  const handleServiceAction = async (action, service, cron = false) => {
    setAnchorElService(null);
    setAnchorServiceMenuItem(null);
    switch (action) {
      case "run":
        await runService(instance.id, service.id, "run");
        setTimeout(() => loadServices(instance), 1000);
        break;
      case "edit":
        const configData = await fetchConfigurationData(service.id, instance.id);
        setConfiguration(configData);

        setFormData(configData?.metadata || {});
        setPrevisouFormData(configData?.metadata || {});

        const re = await buildSchema(
          database,
          configData?.services?.jsonschema, {
          workspace_id: workspaceId,
          project_id: projectId,
          instance_id: instance?.id,
          service_id: service.id,
          component_id: instance?.component_id
        })

        setSchema(re);
        setUischema(configData?.services?.jsonschema_form || {});

        setIsDrawerConfigForm(true);
        break;
      case "list-cron":
        // Fetch service data directly to ensure we have it even if no configuration exists
        const { data: cronServiceData, error: cronServiceError } = await database
          .from("services")
          .select("id, name, jsonschema, jsonschema_form, logo")
          .eq("id", service.id)
          .single();

        // Load the configuration timeline list
        await loadConfigurationsTimeline(service.id, instance.id);

        // Create a configuration object with service data
        setConfiguration({
          service_id: service.id,
          instance_id: instance.id,
          metadata: null,
          services: cronServiceData
        });

        const rc = await buildSchema(
          database,
          cronServiceData?.jsonschema, {
          workspace_id: workspaceId,
          project_id: projectId,
          instance_id: instance?.id,
          service_id: service.id,
          component_id: instance?.component_id
        })

        // Always use the service schema and uischema
        setSchema(rc);
        setUischema(cronServiceData?.jsonschema_form || {});
        setIsDrawerConfigCron(true);
        break;
      case "remove":
        if (
          await dialogs.confirm(
            t('configurations.delete.confirm')
          )
        ) {
          await runService(instance.id, service.id, "remove");
          await database
            .from("configurations")
            .delete()
            .eq("instance_id", instance.id)
            .eq("service_id", service.id);
          loadServices(instance);
        }
        break;
      case "enable":
        const { data: serviceData, error: serviceError } = await database
          .from("services")
          .select("id, name, jsonschema, jsonschema_form, logo")
          .eq("id", service.id)
          .single();

        // Préparer la configuration pour un nouveau service
        const newConfiguration = {
          metadata: null,
          instance_id: instance.id,
          service_id: service.id,
          services: serviceData,
        };

        setConfiguration(newConfiguration);

        const ra = await buildSchema(
          database,
          serviceData?.jsonschema, {
          workspace_id: workspaceId,
          project_id: projectId,
          instance_id: instance?.id,
          service_id: service.id,
          component_id: instance?.component_id
        })

        setSchema(ra);
        setUischema(serviceData?.jsonschema_form || {});
        setFormData({});
        setPrevisouFormData({});
        setIsDrawerConfigForm(true);
        break;
      case "details":
        // Récupérer les détails HTTP de la configuration
        const { data: detailsData, error: detailsError } = await database
          .from("configurations")
          .select(
            "last_http_status, last_http_headers, last_http_response, last_http_error, last_http_time, services(id, name, jsonschema, jsonschema_form, logo)"
          )
          .eq("instance_id", instance.id)
          .eq("service_id", service.id)
          .single();

        setConfigurationDetails(detailsData || {});
        setIsDrawerDetails(true);
        // setConfigurations((prevConfigurations) =>
        //   prevConfigurations.map((config) =>
        //     config.service_id === service.id
        //       ? { ...config, last_http_status: detailsData.last_http_status }
        //       : config
        //   )
        // );
        setTimeout(() => loadServices(instance), 500);
        break;
      case "logs":
        router.navigate(`/logs?instance_id=${instance.id}`);
        //close the drawer
        setAnchorElService(null);
        setAnchorServiceMenuItem(null);
        setDrawerServices(false);
        setFormErrors(null);
        setFormData({});
        setPrevisouFormData({});
        setConfiguration(null);
        setSelectedDate(null);
        setHasTriedToSave(false);
        break;
      default:
        break;
    }
  };

  // Fonction utilitaire pour sauvegarder une configuration timeline
  const saveConfigurationTimeline = async () => {
    if (currentTimelineConfig?.id) {
      // Update existing configuration timeline
      const { error } = await database
        .from("configurations_timeline")
        .update({
          metadata: formData,
          execution_date: selectedDate ? selectedDate.format() : currentTimelineConfig.execution_date
        })
        .eq("id", currentTimelineConfig.id);
      if (error) throw error;
    } else {
      // Insert new configuration timeline
      if (!selectedDate) {
        events.dispatch("alert-message", {
          data: { message: t('configurations_timeline.errors.select_date'), severity: "error" },
        });
        return false;
      }

      // We still need service_id and instance_id to create a timeline
      // but we don't check for an existing configuration
      if (!configuration.service_id || !configuration.instance_id) {
        events.dispatch("alert-message", {
          data: { message: t('configurations_timeline.errors.service_incomplete'), severity: "error" },
        });
        return false;
      }

      const { error } = await database
        .from("configurations_timeline")
        .insert({
          metadata: formData,
          service_id: configuration.service_id,
          instance_id: configuration.instance_id,
          execution_date: selectedDate.format(),
          applied: false
        });
      if (error) throw error;
    }

    // Refresh the timeline list after saving
    await loadConfigurationsTimeline(configuration.service_id, configuration.instance_id);

    return true;
  };

  // Fonction utilitaire pour sauvegarder une configuration standard
  const saveConfiguration = async () => {
    if (configuration?.metadata == null) {
      // Insert new configuration
      const { error } = await database
        .from("configurations")
        .insert({
          instance_id: configuration.instance_id,
          service_id: configuration.service_id,
          metadata: formData,
        })
        .select()
        .single();
      if (error) throw error;

      await runService(configuration.instance_id, configuration.service_id, "create");

      // added AB
      setTimeout(() => {
        loadServices(instance);
      }, 500);
      
    } else {
      // Update existing configuration
      const { error } = await database
        .from("configurations")
        .update({ metadata: formData })
        .eq("instance_id", configuration.instance_id)
        .eq("service_id", configuration.service_id)
        .select();
      if (error) throw error;

      await runService(configuration.instance_id, configuration.service_id, "update");

      // added AB
      setTimeout(() => {
        loadServices(instance);
      }, 500);
      
    }
  };

  // Fonction principale de sauvegarde
  const save = async () => {
    setHasTriedToSave(true);

    // Validation des erreurs
    if (formErrors && formErrors.length) {
      events.dispatch("alert-message", {
        data: { message: t('commons.errors.fix_errors'), severity: "error" },
      });
      return;
    }

    try {
      // Sauvegarder selon le contexte (cron ou configuration standard)
      let saveSuccess = true;
      if (isCron) {
        saveSuccess = await saveConfigurationTimeline();
        if (!saveSuccess) return; // Ne pas continuer si la sauvegarde a échoué
      } else {
        await saveConfiguration();
      }

      // Recharger les services après la sauvegarde
      setTimeout(() => loadServices(instance), 1000);
    } catch (error) {
      events.dispatch("alert-message", {
        data: {
          message: t('configurations.save_error'),
          severity: "error",
        },
      });
      return; // Sortir sans fermer les tiroirs en cas d'erreur
    } finally {

    }

    // Fermer les tiroirs
    setIsDrawerConfigForm(false);
    setIsDrawerDetails(false);

    // Ne pas réinitialiser schema et uischema pour préserver les données du formulaire
    // pour les configurations timeline
    if (!isCron) {
      setSchema({});
      setUischema({});
      setConfiguration(null);
    }

    // Réinitialiser les autres états
    setFormErrors(null);
    setFormData({});
    setPrevisouFormData({});
    setSelectedDate(null);
    setHasTriedToSave(false);
  };

  const setFormResult = ({ data, errors }) => {

    setFormData(data);
    setFormErrors(errors);
  };


  /**
   * Ferme un tiroir spécifique et réinitialise les états associés
   * @param {string} drawerType - Type de tiroir à fermer ('services', 'configCron', 'configForm', 'details')
   */
  const closeDrawer = (drawerType) => {
    switch (drawerType) {
      case "services":
        // Fermer le tiroir des services et réinitialiser les états associés
        setDrawerServices(false);
        setServices([]);
        setConfigurations([]);
        setInstance(null);
        break;
      case "configCron":
        // Fermer le tiroir des configurations cron
        setIsDrawerConfigCron(false);
        setIsCron(false);
        setCurrentTimelineConfig(null);
        setSelectedDate(null);
        loadServices(instance);
        break;
      case "configForm":
        // Fermer le tiroir du formulaire de configuration
        setIsDrawerConfigForm(false);

        // Ne pas réinitialiser schema et uischema si on est en mode cron
        // pour préserver les données du formulaire pour les configurations timeline
        if (!isCron) {
          setSchema({});
          setUischema({});
        }

        // Réinitialiser les autres états
        setFormErrors(null);
        setFormData({});
        setPrevisouFormData({});
        // Only reset configuration if not in cron mode to preserve service info for timeline drawer
        if (!isCron) {
          setConfiguration(null);
        }
        setCurrentTimelineConfig(null);
        setHasTriedToSave(false);
        break;
      case "details":
        // Fermer le tiroir des détails
        setIsDrawerDetails(false);
        setConfigurationDetails({});
        break;
      default:
        break;
    }
  };

  /**
   * Charge la liste des configurations timeline pour un service et une instance donnés
   * @param {string} serviceId - L'ID du service
   * @param {string} instanceId - L'ID de l'instance
   */
  const loadConfigurationsTimeline = async (serviceId, instanceId) => {
    try {
      const { data: configDataListCron, error: configErrorListCron } = await database
        .from("configurations_timeline")
        .select(
          "id, execution_date, applied, service_id, instance_id"
        )
        .eq("service_id", serviceId)
        .eq("instance_id", instanceId);

      if (configErrorListCron) {
        throw configErrorListCron;
      }

      setConfigurationsTimeline(configDataListCron || []);
    } catch (error) {
      events.dispatch("alert-message", {
        data: {
          message: t('configurations_timeline.errors.loading'),
          severity: "error",
        },
      });
    }
  };

  /**
   * Supprime une configuration timeline après confirmation
   * @param {Object} config - La configuration timeline à supprimer
   */
  const removeConfigCron = async (config) => {
    if (await dialogs.confirm(t('configurations_timeline.delete.confirm'))) {
      try {
        const { error } = await database
          .from("configurations_timeline")
          .delete()
          .eq("id", config.id);

        if (error) {
          throw error;
        }

        await loadConfigurationsTimeline(config.service_id, config.instance_id);
      } catch (error) {
        events.dispatch("alert-message", {
          data: {
            message: t('configurations_timeline.delete.error'),
            severity: "error",
          },
        });
      }
    }
  }

  return (
    <>
      <Drawer open={isDrawerServices}
        anchor="right"
        sx={{ overflow: "none" }}
        onClose={(event, reason) => {
          if (reason === "backdropClick") return;
          closeDrawer("services");
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >

          <Breadcrumbs aria-label="breadcrumb">
            <Typography sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }}>
              {instance?.components?.logo && <img
                src={instance?.components?.logo}
                style={{ width: 24, height: 24, marginRight: 10 }}
              />}
              {t(instance?.components?.name)}
              {instance?.metadata?.displayName && ` ${instance.metadata.displayName}`}
            </Typography>
          </Breadcrumbs>
          <Box sx={{ flexGrow: 1 }} />
          <Button onClick={() => closeDrawer("services")}>{t('buttons.close')}</Button>
        </DialogTitle>
        <DialogContent
          sx={{
            width: {
              xs: "90vw",
              sm: "80vw",
              md: "70vw",
              lg: "60vw",
              xl: "50vw",
            }
          }}
        >
          {helpConfigurationMsg &&
            <Alert severity="info" onClose={() => { }}
              action=
              {helpConfigurationLink && <Button color="inherit" size="small" onClick={() => {
                window.open(helpConfigurationLink, "_blank");
              }}>
                {t('buttons.help')}
              </Button>}
            >
              {helpConfigurationMsg}
            </Alert>
          }
          <Menu
            sx={{ mt: "45px" }}
            id="menu-appbar"
            anchorEl={anchorElService}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={Boolean(anchorElService)}
            onClose={() => {
              setAnchorElService(null);
              setAnchorServiceMenuItem(null)
            }}
          >
            {anchorServiceMenuItem && ( // AB added isSystem condition for delete and logs
              <>
                <MenuItem disabled={isHttpBlocked(anchorServiceMenuItem.id)} onClick={() => handleServiceAction("list-cron", anchorServiceMenuItem)}>
                  <AccessTimeIcon sx={{ mr: 1 }} /> {t('buttons.scheduled')}
                </MenuItem> 
                {isServiceConfiguration(anchorServiceMenuItem.id) && <>
                  {isSystem && <MenuItem disabled={isHttpBlocked(anchorServiceMenuItem.id)} onClick={() => handleServiceAction("logs", anchorServiceMenuItem)}>
                    <FormatListBulletedIcon sx={{ mr: 1 }} /> {t('buttons.logs')}
                  </MenuItem>}
                  {isWriteAccess && isSystem && <MenuItem disabled={isHttpBlocked(anchorServiceMenuItem.id)} onClick={() => handleServiceAction("remove", anchorServiceMenuItem)}>  
                    <DeleteIcon sx={{ mr: 1 }} /> {t('buttons.delete')}
                  </MenuItem>}
                  {isWriteAccess && <MenuItem disabled={isHttpBlocked(anchorServiceMenuItem.id)} onClick={() => handleServiceAction("run", anchorServiceMenuItem)}>
                    <PlayArrowIcon sx={{ mr: 1 }} /> {t('buttons.force')}
                  </MenuItem>}</>}
              </>
            )}
          </Menu>
          <List sx={{ width: "100%" }}>
            {Object.keys(groupedServices)
              .sort()
              .map((category) => (
                <React.Fragment key={category}>
                  {/* <ListSubheader sx={{background:'inherit'}}>{category}</ListSubheader> */}
                  <ListItem
                    secondaryAction={
                      <IconButton
                        edge="end"
                        aria-label="expand"
                        onClick={() => {
                          setOpenServiceCategory((prev) =>
                            prev.includes(category)
                              ? prev.filter((cat) => cat !== category)
                              : [...prev, category]
                          );
                        }}
                      >
                        {openServiceCategory.includes(category) ? (
                          <ExpandMoreIcon />
                        ) : (
                          <ExpandMoreIcon sx={{ transform: "rotate(180deg)" }} />
                        )}
                      </IconButton>
                    }>
                    <ListItemText primary={category}></ListItemText>
                  </ListItem>
                  <Divider />
                  <Collapse in={openServiceCategory.includes(category)} timeout="auto" unmountOnExit>
                    {groupedServices[category].map((s) => (
                      <React.Fragment key={s.services.id}>
                        <ListItem
                          secondaryAction={
                            <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                              {!isServiceConfiguration(s.services.id) && (
                                <>
                                  {isWriteAccess && <Button onClick={() => handleServiceAction("enable", s.services)}>
                                    {t('buttons.enable')}
                                  </Button>}
                                </>
                              )}
                              {countScheduledConfigs.find(c => c.service_id == s.services.id)?.services > 0 && <IconButton onClick={() => handleServiceAction("list-cron", s.services)}>
                                <Badge badgeContent={countScheduledConfigs.find(c => c.service_id == s.services.id).services} color="primary">
                                  <AccessTimeIcon />
                                </Badge>
                              </IconButton>}
                              {isServiceConfiguration(s.services.id) && (
                                <>
                                  {isHttpLoading(s.services.id) &&
                                    <Box sx={{ marginTop: 1, marginRight: 2 }}><CircularProgress color="inherit" size={20} /></Box>}
                                  <IconButton disabled={isHttpBlocked(s.services.id)} onClick={() => handleServiceAction("edit", s.services)}>
                                    <SettingsSuggestIcon />
                                  </IconButton>
                                  <IconButton onClick={() => handleServiceAction("details", s.services)}>
                                    <OutputIcon
                                      color={isHttpError(s.services.id) ? "error" : "success"}
                                    />
                                  </IconButton>
                                </>
                              )}
                              <IconButton
                                edge="end"
                                onClick={(e) => {
                                  setAnchorElService(e.currentTarget);
                                  setAnchorServiceMenuItem(s.services);
                                }}
                              >
                                <MoreVertIcon />
                              </IconButton>
                            </Box>
                          }
                        >
                          <ListItemIcon>
                            <img
                              src={s.services.logo}
                              style={{ width: 32, height: 32, marginRight: 10 }}
                            />
                          </ListItemIcon>
                          <ListItemText
                          primary={t(s.services.name)} secondary={t(s.services.description)}> // ADDED T-TEST
                          </ListItemText>
                        </ListItem>
                        <Divider />
                      </React.Fragment>
                    ))}
                  </Collapse>
                </React.Fragment>
              ))}
          </List>
          {/* <MaterialReactTable table={table} /> */}
        </DialogContent>
      </Drawer>

      <Drawer open={isDrawerConfigCron}
        anchor="right" onClose={(event, reason) => {
          if (reason === "backdropClick") return;
          closeDrawer("configCron");
        }}>
        <DialogTitle
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          

          <Breadcrumbs aria-label="breadcrumb">
            <Typography sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }}>
              {instance?.components?.logo && <img
                src={instance?.components?.logo}
                style={{ width: 24, height: 24, marginRight: 10 }}
              />}
              {t(instance?.components?.name)}</Typography>
            <Typography sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }}>
              {configuration?.services?.logo && <img
                src={configuration.services.logo}
                style={{ width: 24, height: 24, marginRight: 10 }}
              />}
              {t(configuration?.services?.name)}&nbsp;<small>(scheduled)</small></Typography>
          </Breadcrumbs>

          <Box sx={{ flexGrow: 1 }} />
          {isWriteAccess && <Button
            startIcon={<AddIcon />}
            color="primary"
            variant="outlined"
            sx={{ mr: 1 }}
            onClick={() => {
              // We can proceed even if there's no existing configuration
              // The configuration object should have been set up with at least service_id and instance_id
              // when opening the timeline drawer

              setIsCron(true);
              setCurrentTimelineConfig(null);
              setFormData({});
              setPrevisouFormData({});
              // Set default date to tomorrow
              const tomorrow = dayjs().add(1, 'day');
              setSelectedDate(tomorrow);
              setIsDrawerConfigForm(true);
            }}
          >
            {t('buttons.add')}
          </Button>}
          <Button onClick={() => {
            closeDrawer("configCron");
          }}>{t('buttons.close')}</Button>
        </DialogTitle>
        <DialogContent
          sx={{
            width: {
              xs: "90vw",
              sm: "80vw",
              md: "70vw",
              lg: "60vw",
              xl: "50vw",
            }
          }}>
          {helpConfigurationCronMsg &&
            <Alert severity="info" onClose={() => { }}
              action=
              {helpConfigurationCronLink && <Button color="inherit" size="small" onClick={() => {
                window.open(helpConfigurationCronLink, "_blank");
              }}>
                {t('buttons.help')}
              </Button>}
            >
              {helpConfigurationCronMsg}
            </Alert>}
          <List>
            {configurationsTimeline.map((config) => (
              <React.Fragment key={config.id}><ListItem

                secondaryAction={
                  <Stack direction="row" spacing={1}>
                    <IconButton
                      onClick={async () => {
                        setIsCron(true);
                        const { data: configDataCron, error: configErrorCron } = await database
                          .from("configurations_timeline")
                          .select("id, metadata, applied, execution_date")
                          .eq("id", config.id)
                          .single();

                        setCurrentTimelineConfig(configDataCron);
                        setFormData(configDataCron?.metadata || {});
                        setPrevisouFormData(configDataCron?.metadata || {});
                        if (configDataCron?.execution_date) {
                          setSelectedDate(dayjs(configDataCron.execution_date));
                        }
                        setIsDrawerConfigForm(true);
                      }}
                    >
                      <SettingsSuggestIcon />
                    </IconButton>
                    <IconButton
                      onClick={() => removeConfigCron(config)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Stack>
                }
              >
                <ListItemText
                  primary={t('configurations_timeline.execution_date') + ": " + (new Date(config.execution_date).toLocaleString())}
                  secondary={config.applied ? t('commons.status') + ": " + t('commons.executed') : t('commons.status') + ": " + t('commons.pending')}
                />
              </ListItem>
                <Divider />
              </React.Fragment>
            ))}
          </List>
        </DialogContent>
      </Drawer>

      <Drawer open={isDrawerConfigForm}
        anchor="right"
        onClose={(event, reason) => {
          if (reason === "backdropClick") return;
          closeDrawer("configForm");
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          
          <Breadcrumbs aria-label="breadcrumb">
            <Typography sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }}>
              {instance?.components?.logo && <img
                src={instance?.components?.logo}
                style={{ width: 24, height: 24, marginRight: 10 }}
              />}
              {t(instance?.components?.name)}</Typography>
            <Typography sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }}>
              {configuration?.services?.logo && <img
                src={configuration.services.logo}
                style={{ width: 24, height: 24, marginRight: 10 }}
              />}
              {configuration?.services.name}&nbsp;
              {isCron && <small>(scheduled)</small>}
              {isCron && selectedDate && <small style={{ marginLeft: '5px' }}>({selectedDate.format('DD/MM/YYYY')})</small>}
                {isCron && currentTimelineConfig?.applied &&
                  <small style={{ marginLeft: '10px'}}>
                    &nbsp;
                    {t('configurations_timeline.readonly')}
                  </small>
                }
              </Typography>
          </Breadcrumbs>

          <Box sx={{ flexGrow: 1 }} />
          <Stack direction="row" spacing={1}>
            {isWriteAccess && <Button
              onClick={() => save()}
              color="success"
              variant="outlined"
              startIcon={<SaveAltIcon />}
              disabled={isCron && currentTimelineConfig?.applied}
            >
              {t('buttons.save')}
            </Button>}
            <Button onClick={() => {
              closeDrawer("configForm");
            }}>{t('buttons.cancel')}</Button>
          </Stack>
        </DialogTitle>
        <DialogContent sx={{
          width: {
            xs: "90vw",
            sm: "80vw",
            md: "70vw",
            lg: "60vw",
            xl: "50vw",
          }
        }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              flexGrow: 1,
              height: 0,
            }}
          >
            <Box sx={{ flexGrow: 1, paddingTop: 2 }}>
              {isDrawerConfigForm && (
                <Box className="jsonforms">
                  {isCron && <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      label={t('configurations_timeline.execution_date_time')}
                      sx={{ marginTop: 1, width: '100%', marginBottom: 2 }}
                      disabled={!isWriteAccess || (isCron && currentTimelineConfig?.applied)}
                      value={selectedDate}
                      onChange={(newValue) => setSelectedDate(newValue)}
                      slotProps={{
                        textField: {
                          helperText: t('configurations_timeline.execution_date_time_helper'),
                          required: !currentTimelineConfig?.id
                        }
                      }}
                    />
                  </LocalizationProvider>}
                  <CustomJsonForm
                    schema={schema}
                    uischema={uischema}
                    data={{ ...formData }}
                    onChange={setFormResult}
                    contextVars={{
                      workspace_id: workspaceId,
                      project_id: projectId,
                      instance_id: configuration?.instance_id,
                      service_id: configuration?.service_id,
                      component_id: instance?.component_id
                    }}
                    validationMode={hasTriedToSave ? 'ValidateAndShow' : 'ValidateAndHide'}
                    config={{ showUnfocusedDescription: true }}
                  />
                </Box>
              )}
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-start", padding: "20px" }}>
          <small>
            <Trans
              i18nKey="configurations.helper_secrets"
              components={{ code: <code /> }}
              values={{}} // pas de variable
            />
          </small>
        </DialogActions>
      </Drawer>

      <Drawer open={isDrawerDetails}
        anchor="right"
        onClose={() => closeDrawer("details")}
      >
        <DialogTitle
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          
          <Breadcrumbs aria-label="breadcrumb">
            <Typography sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }}>
              {instance?.components?.logo && <img
                src={instance?.components?.logo}
                style={{ width: 24, height: 24, marginRight: 10 }}
              />}
              {t(instance?.components?.name)}</Typography>
            <Typography sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }}>
              {configurationDetails?.services?.logo && <img
                src={configurationDetails.services.logo}
                style={{ width: 24, height: 24, marginRight: 10 }}
              />}
              {t(configurationDetails?.services?.name)}</Typography>
          </Breadcrumbs>
          <Box sx={{ flexGrow: 1 }} />
          <Stack direction="row" spacing={1}>
            <Button onClick={() => {
              closeDrawer("details");
            }}>{t('buttons.close')}</Button>
          </Stack>
        </DialogTitle>
        {/* <DialogTitle>{configuration.services.name}</DialogTitle> */}
        <DialogContent sx={{
          width: {
            xs: "90vw",
            sm: "80vw",
            md: "70vw",
            lg: "60vw",
            xl: "50vw",
          }
        }}>
          <Box sx={{ width: "100%", pt: 2 }}>
            <List sx={{ width: "100%" }}>
              {/* "last_http_status, last_http_headers, last_http_response, last_http_error, last_http_time" */}
              <ListItem>
                <ListItemText>
                  <Typography>{t('configurations.http.last_http_status')}</Typography>
                  <pre>
                    <code>{configurationDetails.last_http_status}</code>
                  </pre>
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemText>
                  <Typography>{t('configurations.http.last_http_headers')}</Typography>
                  <pre style={{ overflow: "auto" }}>
                    <code>
                      {JSON.stringify(
                        configurationDetails.last_http_headers,
                        null,
                        " "
                      )}
                    </code>
                  </pre>
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemText>
                  <Typography>{t('configurations.http.last_http_reponse')}</Typography>
                  <pre style={{ overflow: "auto" }}>
                    <code>{configurationDetails.last_http_response}</code>
                  </pre>
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemText>
                  <Typography>{t('configurations.http.last_http_error')}</Typography>
                  <pre style={{ overflow: "auto" }}>
                    <code>{configurationDetails.last_http_error}</code>
                  </pre>
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemText>
                  <Typography>{t('configurations.http.last_http_time')}</Typography>
                  <pre>
                    <code>{configurationDetails.last_http_time}</code>
                  </pre>
                </ListItemText>
              </ListItem>
            </List>
          </Box>
        </DialogContent>
      </Drawer>
    </>
  );
}
